import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.css";
import { Facebook, Linkedin, Instagram,Youtube ,Mail, Phone, MapPin } from "lucide-react";
import logo from "../img/ff.png"; 
// replace with your logo path

const Footer = () => {
  return (
    <footer className="edu-footer">
      <div className="footer-container container">
        <div className="row gy-5">
          {/* About / Logo Section */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-about">
              <img src={logo} alt="Auxilium ITI Logo" className="footer-logo mb-3" />
              <h5 className="fw-bold text-uppercase mb-3 text-white">Auxilium ITI</h5>
              <p className="footer-text">
                Empowering students with skills, discipline, and values to build a brighter and successful future.
              </p>
              <div className="footer-social mt-3">
                <a href="#"><Facebook size={18} /></a>
                <a href="#"><Linkedin size={18} /></a>
                <a href="https://www.instagram.com/auxiliumititpt?igsh=NWk5YW9jczhlcHhl"><Instagram size={18} /></a>
                <a href="https://youtube.com/@auxiliumttc4676?si=tDqU9Qf0sl4vT05a"><Youtube size={18} /></a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6">
            <h6 className="footer-title">Quick Links</h6>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/coursesoffered">Courses</Link></li>
              <li><Link to="/gallary">Gallery</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-lg-3 col-md-6">
            <h6 className="footer-title">Contact</h6>
            <ul className="footer-contact">
           
              <li><MapPin size={20} /> &nbsp;21-A, (Gandhi Road), Railway Station Road, Post Box No.6, Tirupattur, Tirupattur District-635601</li>
              <li><Phone size={16} /> &nbsp; 9385201431, 9487271432</li>
              <li><Mail size={16} /> &nbsp; auxiliumttc1973@gmail.com</li>
            </ul>
          </div>

          {/* Embedded Map */}
          <div className="col-lg-3 col-md-6">
            <h6 className="footer-title">Location</h6>
            <div className="map-container">
              <iframe
                title="Auxilium ITI Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3895.295593894825!2d78.5620522745396!3d12.496556125116323!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bac538a3d5b6841%3A0x31b698310df28980!2sMary%20Christian%20Church!5e0!3m2!1sen!2sin!4v1762503044153!5m2!1sen!2sin"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>

        <hr className="footer-divider" />

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Auxilium ITI. All Rights Reserved.
            <br/>  Developed by SkyBros IT Solutions, TPT.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
